export default __webpack_public_path__ + "navigation-guide-device-notification-960-f7d10bad4c876015be0bcd0efe64d013.png";